import React from 'react'
import { getColorTheme, mq } from '../../utils'
import { Image } from '../Image'
import { Text } from '../Text'
import { IProps } from './index'
import { AllColorValues } from '../../utils'
import hyperlinkIcon from '../../../images/hyperlink-icon.png'
import { WiredCardElement as WiredCardElementDefault } from './element'
import { NewBrandingHoc } from '../../utils/NewBrandingHoc'

export const WiredCardElementLegacy = ({
  title,
  description,
  companyLogo,
  companyName,
  customerStoryLink,
  bgColor,
}: IProps): React.ReactElement => {
  const themeColors = getColorTheme('legacy', bgColor)
  const isPercentage = title && /^\d+(\.\d+)?%$/.test(title)
  const includesX = title && title.includes('x')

  const boxShadow =
    themeColors.backgroundColor === AllColorValues.LegacyWhite ||
    themeColors.backgroundColor === AllColorValues.LegacyLightGray
      ? '0px 1px 20px rgba(0, 0, 0, 0.08)'
      : 'none'

  return (
    <>
      <div className="wired-card-wrapper" data-testid="wired-card">
        {title && (
          <div className="wired-card-title">
            <Text size="xxl++">{title.replace('%', '').replace('x', '')}</Text>
            {isPercentage && <Text size="lg-percentage">{'%'}</Text>}
            {includesX && <Text size="lg-percentage">{'x'}</Text>}
          </div>
        )}
        <div className="wired-card-body">
          <Text size="body">{description}</Text>
        </div>
        {companyLogo && (
          <div className="wired-card-logo">
            <Image url={companyLogo} altText={companyName} />
            {customerStoryLink && (
              <a
                className="wired-card-link"
                href={customerStoryLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Image url={hyperlinkIcon} />
              </a>
            )}
          </div>
        )}
      </div>

      <style jsx>{`
        .wired-card-wrapper {
          color: ${themeColors.textColor};
          background-color: ${themeColors.backgroundColor};
          box-shadow: ${boxShadow};
        }
      `}</style>

      <style jsx>
        {`
          .wired-card-wrapper {
            display: flex;
            flex-direction: column;
            width: 16.25rem;
            min-height: 16.25rem;
            padding: 1.906rem;
            border-radius: 20px;
            align-items: center;
            justify-content: center;
          }

          .wired-card-body {
            text-align: center;
          }

          .wired-card-logo {
            margin-top: 1.1rem;
            display: flex;
            flex-direction: row;
            align-items: center;
          }

          .wired-card-link {
            padding-left: 13px;
          }

          :global(.wired-card-logo > picture img) {
            max-width: 170px;
            max-height: 50px;
          }

          :global(.wired-card-logo .wired-card-link picture img) {
            width: 13px;
          }

          @media (${mq.desktop}) {
            .wired-card-wrapper {
              border-radius: 25px;
              width: 20.188rem;
              min-height: 14.375rem;
              max-height: 14.375rem;
              padding: 2.05rem 2rem;
            }
          }
        `}
      </style>
    </>
  )
}

export const WiredCardElement = NewBrandingHoc(WiredCardElementLegacy, WiredCardElementDefault)
